import React from "react";

export default class SerotoninSyndrome extends React.Component {
  render() {
    return (
      <>
        <p>
          Serotonine syndrom is caused by an excess of serotonine in the brain
          and other parts of the body, accumulated in result of blocking of it's
          reuptake or inhibition of monoaminoxidais that is breaks it down. It
          can occur in effect of ingesting big doses of empathogenic
          serotonergics like MDMA (ecstasy) or mixing them with other substances
          working on a simmilar mechanisms, like i.e. antidepressants (mostly
          three-ring anti depressant medication) or MAO inhibitors or other
          substances, that affect the serotonine levels.
        </p>
        <p>
          Serotonin syndrom is very often a direct life threatening situation!
        </p>
        <h3>Symptoms:</h3>
        <p>
          Fever (even above 40 C), chills, seizures, diarrhea, nausea, high
          blood pressure, lack of movement coordination, heart arythmy, too fast
          heart rate, anxiety and desorientation, fainting, shortlasting and
          reocurring lossess of conciousness.{" "}
        </p>
        <h3>What to do?</h3>
        <p>
          If suspecting serotonin syndrome, immiedietly call an ambulance and
          inform them about ingesting the likely substance. Keep the victim
          conciouss, fight hipathermia through doing coldd compressess.
        </p>
      </>
    );
  }
}
